import { render } from "./ClassicContactForm.vue?vue&type=template&id=62bad9cc&scoped=true"
import script from "./ContactForm.js?vue&type=script&lang=js&external"
export * from "./ContactForm.js?vue&type=script&lang=js&external"

import "./ClassicContactForm.vue?vue&type=style&index=0&id=62bad9cc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62bad9cc"]])

export default __exports__